import React, { useState, useEffect } from "react";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import ghanaLogo from "../../assets/images/ghanaLOgoImage.jpg";
import { enqueueSnackbar } from "notistack";
import LogoContainer from "./LogoContainer";
import { otp_verification } from "../../../DAL/auth/auth";
import { Button } from "@mui/material";
import DashboardHeader from "../../headers/DashboardHeader";

export default function OrtpVerifyViaLogin() {
  // ... [keep all your existing state and handlers] ...
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [errors, setErrors] = React.useState({ verification_code: "" });

  const navigate = useNavigate();
  const [loginStates, setLoginStates] = useState({
    email: "",
    password: "",
    loading: false,
    verification_code: "",
    phoneNumber: "",
  });
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmationEmail, setConfirmationEmail] = useState("");
  const location = useLocation();

  const type = location?.state?.type;
  const selectedMethod = location?.state?.selectedMethod;

  useEffect(() => {
    if (location.state?.accountCreated) {
      setShowConfirmation(true);
      setConfirmationEmail(location.state.email);
    }
  }, [location]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Only allow digits for OTP
    if (value.length > 6) {
      setErrors((prev) => ({
        ...prev,
        verification_code: "You can only type a 6-digit OTP",
      }));
      return; // prevents updating the value
    }

    // Clear error on change
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setLoginStates({ ...loginStates, [name]: value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    let hasError = false;

    // Check if OTP is empty
    if (!loginStates.verification_code) {
      setErrors((prev) => ({
        ...prev,
        verification_code: "Verification code is required",
      }));
      hasError = true;
    } else {
      setErrors((prev) => ({ ...prev, verification_code: "" }));
    }

    if (hasError) return;
    const sourceValue = location?.state?.sorceValue;
    setLoading(true);

    const data = {
      source_type: selectedMethod,
      source: sourceValue,
      verification_code: loginStates.verification_code,
    };

    const response = await otp_verification(data);

    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      setLoading(false);

      navigate("/dashboard");
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
    }
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   let hasError = false;

  //   if (!loginStates.verification_code) {
  //     enqueueSnackbar("OTP is required", { variant: "error" });
  //     return;
  //   }

  //   if (!loginStates.verification_code) {
  //     setErrors((prev) => ({
  //       ...prev,
  //       verification_code: "Verification code is required",
  //     }));
  //     hasError = true;
  //   } else {
  //     setErrors((prev) => ({ ...prev, verification_code: "" }));
  //   }

  //   if (hasError) return;

  //   enqueueSnackbar("Verification Successfull", { variant: "success" });

  //   navigate("/dashboard");
  // };

  return (
    <div className="header-container">
      <DashboardHeader />
      <div className="pageContainer">
        {/* Left Side - Full Logo Section */}
        <LogoContainer />

        {/* Right Side - Login Form */}
        <div style={styles.formContainer}>
          <div style={styles.formContent}>
            <h2 style={styles.signInTitle}>
              {selectedMethod === "sms"
                ? "Verification code has been sent to your provided phone number"
                : "Verification code has been sent to your provided email ID"}
            </h2>
            {selectedMethod == "email" && (
              <Alert> Your OTP has been successfully sent to your email.</Alert>
            )}
            {selectedMethod == "sms" && (
              <Alert>
                {" "}
                Your OTP has been successfully sent to your mobile number.
              </Alert>
            )}

            <form onSubmit={handleSubmit} style={styles.form}>
              {(selectedMethod === "email" || !selectedMethod) && (
                <div style={styles.formGroup}>
                  <label htmlFor="email" style={styles.label}>
                    Email *
                  </label>
                  <input
                    className="validated_input"
                    placeholder="Your registered email"
                    required
                    type="email"
                    disabled
                    id="email"
                    name="email"
                    value={loginStates.email}
                    onChange={handleChange}
                    style={styles.input}
                  />
                </div>
              )}

              {selectedMethod === "sms" && (
                <div style={styles.formGroup}>
                  <label htmlFor="phoneNumber" style={styles.label}>
                    Mobile Number *
                  </label>
                  <input
                    className="validated_input"
                    placeholder="Your mobile number"
                    required
                    disabled
                    type="tel"
                    id="phoneNumber"
                    name="phoneNumber"
                    value={loginStates.phoneNumber}
                    onChange={handleChange}
                    style={styles.input}
                  />
                </div>
              )}

              <div style={styles.formGroup}>
                <label htmlFor="Verification_code" style={styles.label}>
                  Verification Code *
                </label>
                <input
                  // maxLength={6}  <-- REMOVE this line to allow typing more than 6 digits
                  className="validated_input"
                  placeholder="Enter OTP"
                  required
                  id="verification_code"
                  name="verification_code"
                  type="number"
                  value={loginStates.verification_code}
                  onChange={handleChange}
                  style={{
                    ...styles.input,
                    borderColor: errors.verification_code ? "red" : "#ccc",
                    outline: errors.verification_code
                      ? "1px solid red"
                      : "none",
                  }}
                />

                {errors.verification_code && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "0.85rem",
                      marginTop: "4px",
                    }}
                  >
                    {errors.verification_code}
                  </div>
                )}
              </div>

              <button
                type="submit"
                className="submit-button"
                style={styles.submitButton}
                disabled={loginStates.loading}
              >
                {loading ? "Verifying..." : "Verify OTP"}
              </button>
            </form>
            <div className="mt-3 text-end">
              <Button className="w-100" onClick={() => navigate(-1)}>
                Change Verification Method
              </Button>
            </div>
          </div>{" "}
        </div>
      </div>
    </div>
  );
}

const styles = {
  logoImage: {
    width: "100%",
    maxWidth: "500px",
    height: "auto",
    marginBottom: "30px",
    objectFit: "contain",
  },
  logoTitle: {
    fontSize: "2.5rem",
    fontWeight: "bold",
    color: "#333",
    marginBottom: "10px",
  },
  logoSubtitle: {
    fontSize: "1.5rem",
    color: "#555",
    fontWeight: "normal",
  },
  formContainer: {
    flex: 1.4, // Increased from 1 to make right side wider
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px",
    backgroundColor: "#f5f5f5",
  },
  formContent: {
    width: "100%",
    maxWidth: "400px",
  },
  signInTitle: {
    // fontSize: "1.8rem",
    // fontWeight: "bold",
    marginBottom: "20px",
    color: "#333",
  },
  form: {
    width: "100%",
  },
  formGroup: {
    marginBottom: "20px",
  },
  label: {
    display: "block",
    marginBottom: "8px",
    fontWeight: "500",
    color: "#333",
  },
  input: {
    width: "100%",
    padding: "12px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    fontSize: "16px",
    boxSizing: "border-box",
  },
  visibilityToggle: {
    position: "absolute",
    right: "10px",
    top: "38px",
    background: "none",
    border: "none",
    cursor: "pointer",
    color: "#666",
  },
  forgotPasswordContainer: {
    textAlign: "right",
    marginBottom: "20px",
  },
  forgotPasswordLink: {
    color: "#15978a",
    textDecoration: "none",
    fontSize: "14px",
  },
  submitButton: {
    width: "100%",
    padding: "14px",
    backgroundColor: "#15978a",
    color: "white",
    border: "none",
    borderRadius: "4px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    marginBottom: "20px",
    transition: "background-color 0.3s",
    "&:hover": {
      backgroundColor: "#15978a",
    },
  },
  signUpContainer: {
    textAlign: "center",
    marginTop: "20px",
  },
  signUpText: {
    color: "#555",
    fontSize: "14px",
    marginBottom: "0", // remove spacing between lines
  },

  signUpLink: {
    color: "#15978a",
    textDecoration: "none",
    fontWeight: "bold",
    marginLeft: "5px",
  },
};
